import { type MouseEvent, type ReactNode } from "react";
import { STICKY_TO_BOTTOM } from "~/common/components/icon/Elevation";
import { DialogActions, DialogContent, DialogHeader, DialogTitle, styled } from "~/common/mui";
import ResponsiveDialogDrawer from "./ResponsiveDialogDrawer";

export interface AtcDialogShellProps {
  children?: ReactNode;
  closeDisabled?: boolean;
  footer?: ReactNode;

  onClose: (e?: MouseEvent) => void;

  title?: string;
}

export const AtcDialogShell = (props: AtcDialogShellProps) => {
  const { children, closeDisabled = false, footer, onClose, title } = props;
  const handleClose = (event?: MouseEvent) => {
    if (!closeDisabled) {
      onClose(event);
    }
  };

  return (
    <ResponsiveDialogDrawer open={true} onClose={handleClose} maxWidth="desktop-l">
      <DialogHeader onClose={handleClose}>
        <DialogTitle>{title}</DialogTitle>
      </DialogHeader>
      <DialogContent>{children}</DialogContent>
      <AtcDialogActions data-testid="atc-dialog-actions">{footer}</AtcDialogActions>
    </ResponsiveDialogDrawer>
  );
};

const AtcDialogActions = styled(DialogActions)(({ theme }) => ({
  [theme.breakpoints.only("phone")]: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: STICKY_TO_BOTTOM,
    position: "relative",
    zIndex: 1,
  },
}));
